import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mb-40" }
const _hoisted_2 = { class: "col-xxl-10 col-lg-8 pe-xxl-8" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "form-group mb-25 position-relative" }
const _hoisted_6 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "form-group mb-25 position-relative" }
const _hoisted_10 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "form-group mb-25 position-relative" }
const _hoisted_14 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group mb-25" }
const _hoisted_18 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { value: "sent" }
const _hoisted_21 = { value: "received" }
const _hoisted_22 = { value: "pending" }
const _hoisted_23 = { value: "ordered" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "form-group mb-25 position-relative" }
const _hoisted_26 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "form-group mb-25" }
const _hoisted_30 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_31 = ["value"]
const _hoisted_32 = { value: "" }
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "col-xxl-2 col-lg-4" }
const _hoisted_35 = { class: "card border-0 rounded-1 w-xxl-5 pt-12 pb-12 mb-md-25 shadow-sm" }
const _hoisted_36 = { class: "table style-two" }
const _hoisted_37 = {
  scope: "row",
  class: "fs-14 text-title lh-1 ls-1 fw-normal"
}
const _hoisted_38 = { class: "fs-14 fw-semibold lh-1 text-optional text-end" }
const _hoisted_39 = {
  scope: "row",
  class: "fs-14 text-title lh-1 ls-1 fw-normal"
}
const _hoisted_40 = { class: "fs-14 fw-semibold lh-1 text-optional text-end" }
const _hoisted_41 = {
  scope: "row",
  class: "fs-14 text-title lh-1 ls-1 fw-normal"
}
const _hoisted_42 = { class: "fs-14 fw-semibold lh-1 text-optional text-end" }
const _hoisted_43 = {
  scope: "row",
  class: "fs-14 text-title lh-1 ls-1 fw-semibold"
}
const _hoisted_44 = { class: "fs-14 fw-bold lh-1 text-purple text-end" }
const _hoisted_45 = { class: "col-12" }
const _hoisted_46 = { class: "form-group mb-25" }
const _hoisted_47 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_48 = ["value", "placeholder"]
const _hoisted_49 = { class: "col-xl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("purchase_page.order_tax_percent")), 1),
            _createElementVNode("input", {
              type: "number",
              value: _ctx.orderTax,
              onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onInput('orderTax', ($event.target as HTMLInputElement).value))),
              class: "w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title h-55 ps-3",
              placeholder: "0"
            }, null, 40, _hoisted_7),
            _cache[8] || (_cache[8] = _createElementVNode("span", {
              class: "percent-sign position-absolute rounded-1 text-center d-flex flex-column justify-content-center",
              style: {"right":"15px","top":"38px"}
            }, " % ", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("purchase_page.discount_amount")), 1),
            _createElementVNode("input", {
              type: "number",
              value: _ctx.discount,
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onInput('discount', ($event.target as HTMLInputElement).value))),
              class: "w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title h-55 ps-3",
              placeholder: "0"
            }, null, 40, _hoisted_11),
            _cache[9] || (_cache[9] = _createElementVNode("span", {
              class: "percent-sign position-absolute rounded-1 text-center d-flex flex-column justify-content-center fw-semibold fs-16",
              style: {"right":"15px","top":"38px"}
            }, " $ ", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("purchase_page.shipping_cost_amount")), 1),
            _createElementVNode("input", {
              type: "number",
              value: _ctx.shipping,
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onInput('shipping', ($event.target as HTMLInputElement).value))),
              class: "w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title h-55 ps-3",
              placeholder: "0"
            }, null, 40, _hoisted_15),
            _cache[10] || (_cache[10] = _createElementVNode("span", {
              class: "percent-sign position-absolute rounded-1 text-center d-flex flex-column justify-content-center fw-semibold fs-16",
              style: {"right":"15px","top":"38px"}
            }, " $ ", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("purchase_page.status")), 1),
            _createElementVNode("select", {
              value: _ctx.status,
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onInput('status', ($event.target as HTMLSelectElement).value))),
              class: "bg-white border-0 rounded-1 fs-14 text-optional w-100 h-55 ps-3"
            }, [
              _createElementVNode("option", _hoisted_20, _toDisplayString(_ctx.$t("purchase_page.purchase_status_sent")), 1),
              _createElementVNode("option", _hoisted_21, _toDisplayString(_ctx.$t("purchase_page.purchase_status_received")), 1),
              _createElementVNode("option", _hoisted_22, _toDisplayString(_ctx.$t("purchase_page.purchase_status_pending")), 1),
              _createElementVNode("option", _hoisted_23, _toDisplayString(_ctx.$t("purchase_page.purchase_status_ordered")), 1)
            ], 40, _hoisted_19)
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("purchase_page.paid_amount")), 1),
            _createElementVNode("input", {
              type: "number",
              value: _ctx.paidAmount,
              onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onInput('paidAmount', ($event.target as HTMLInputElement).value))),
              class: "w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title h-55 ps-3",
              placeholder: "0"
            }, null, 40, _hoisted_27),
            _cache[11] || (_cache[11] = _createElementVNode("span", {
              class: "percent-sign position-absolute rounded-1 text-center d-flex flex-column justify-content-center fw-semibold fs-16",
              style: {"right":"15px","top":"38px"}
            }, " $ ", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("purchase_page.payment_method")), 1),
            _createElementVNode("select", {
              value: _ctx.paymentMethodId ?? '',
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onInput('paymentMethodId', ($event.target as HTMLSelectElement).value))),
              class: "bg-white border-0 rounded-1 fs-14 text-optional w-100 h-55 ps-3"
            }, [
              _createElementVNode("option", _hoisted_32, _toDisplayString(_ctx.$t("purchase_page.select_method")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentMethods, (method) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: method.id,
                  value: method.id
                }, _toDisplayString(method.name), 9, _hoisted_33))
              }), 128))
            ], 40, _hoisted_31)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("table", _hoisted_36, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_37, _toDisplayString(_ctx.$t("purchase_page.order_tax")) + " : ", 1),
              _createElementVNode("td", _hoisted_38, " $" + _toDisplayString(Number(_ctx.calculatedTax).toFixed(2)), 1)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_39, _toDisplayString(_ctx.$t("purchase_page.discount")) + " : ", 1),
              _createElementVNode("td", _hoisted_40, " $" + _toDisplayString(Number(_ctx.discount).toFixed(2)), 1)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_41, _toDisplayString(_ctx.$t("purchase_page.shipping")) + " : ", 1),
              _createElementVNode("td", _hoisted_42, " $" + _toDisplayString(Number(_ctx.shipping).toFixed(2)), 1)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_43, _toDisplayString(_ctx.$t("purchase_page.grand_total")) + " : ", 1),
              _createElementVNode("td", _hoisted_44, "$" + _toDisplayString(Number(_ctx.grandTotal).toFixed(2)), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_45, [
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t("purchase_page.notes")), 1),
        _createElementVNode("textarea", {
          value: _ctx.notes,
          onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onInput('notes', ($event.target as HTMLTextAreaElement).value))),
          cols: "30",
          rows: "5",
          placeholder: _ctx.$t('purchase_page.add_note'),
          class: "d-block w-100 bg-white border-0 rounded-1 resize-none fs-14 text-title p-3"
        }, null, 40, _hoisted_48)
      ])
    ]),
    _createElementVNode("div", _hoisted_49, [
      _createElementVNode("button", {
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('submit'))),
        class: "btn style-one d-inline-block transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 mb-20",
        type: "button"
      }, _toDisplayString(_ctx.$t("purchase_page.submit_purchase")), 1)
    ])
  ]))
}